// extracted by mini-css-extract-plugin
module.exports = {"image":"LifestyleReadMore_image__2OuHj","description":"LifestyleReadMore_description__wJ6lL"};